import { faBan, faCheck, faClock, faEdit, faFile, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React from 'react';
import { Button } from 'react-bootstrap';
import DataTable from '../../collection/DataTable';
import Boolean from '../../collection/icons/Boolean';
import TableHandler from '../../collection/TableHandler';
import ValidacionFilter from '../../components/filters/ValidacionFilter';
import PermisoModal from '../../components/modals/PermisoModal';
import FloatingAddButton from '../../components/project/FloatingAddButton';
import { apiDelete, apiForm, apiGet, apiUrl, getSession } from '../../utils/api';
import { generateFormData, sortableString } from '../../utils/functions';


export default function Permisos(props) {
    // default filter
    const usuario = getSession();
    const defaultFilter = {
        desde: moment().startOf('year').format("YYYY-MM-DD"),
        hasta: null,
        trabajador: props.super ? null : usuario.id,
        pendiente: props.super ? true : null,
        validado: props.super ? null : true
    };
    let filter = generateFormData(defaultFilter);

    // api calls
    const updateData = async newFilter => {
        filter = newFilter ? newFilter : filter;
        return await apiForm("permisos/table", filter);
    }
    const deleteRow = async id => await apiDelete("permisos/delete/" + id);
    const performAction = async (action, id) => await apiGet(`permisos/${action}/${id}`);

    // render
    return <>
        <h2>{`${props.super ? "Validar" : "Solicitar"} permisos`}</h2>
        <TableHandler
            onUpdate={updateData}
            onDelete={deleteRow}
            onAction={performAction}
            elementText="el permiso">
            <ValidacionFilter
                className="my-3"
                defaultValue={defaultFilter}
                selectFechas
                selectDepartamento={props.super && usuario.permisoAdmin}
                selectTrabajador={props.super}
                selectEstado />
            <PermisosTable super={props.super} user={usuario} />
        </TableHandler>
    </>;
}

function PermisosTable(props) {
    // table columns
    let columns = [
        {
            name: "Trabajador",
            selector: row => sortableString(row.NombreTrabajador),
            format: row => row.NombreTrabajador,
            sortable: true,
            omit: !props.super
        },
        {
            name: "Fecha",
            selector: row => moment(row.Fecha).format("YYYY-MM-DD"),
            format: row => moment(row.Fecha).format("DD/MM/YY"),
            sortable: true
        },
        {
            name: "Inicio",
            selector: row => row.StrHoraInicio,
            sortable: true
        },
        {
            name: "Final",
            selector: row => row.StrHoraFin,
            sortable: true
        },
        {
            name: "Comentario",
            selector: row => sortableString(row.Comentario),
            format: row => <span title={row.Comentario}>{row.Comentario}</span>,
            sortable: true
        },
        {
            name: "Validación",
            selector: row => row.Pendiente ? 0 : row.Validado ? 1 : 2,
            format: row => row.Pendiente ?
                <FontAwesomeIcon icon={faClock} className="text-secondary" title="Pendiente" size="lg" /> :
                <Boolean value={row.Validado} trueTitle="Aprobado" falseTitle="Denegado" size="lg" />,
            sortable: true,
            center: true
        }
    ];
    // table buttons
    const buttons = row => {
        const viewBtn = <a href={apiUrl("permisos/justificante/" + row.Id)} target="_blank" > <Button variant="primary" size="sm"><FontAwesomeIcon icon={faFile} /></Button></a>;
        const viewBtnOutlined = <a href={apiUrl("permisos/justificante/" + row.Id)} target="_blank" > <Button variant="outline-primary" size="sm"><FontAwesomeIcon icon={faFile} /></Button></a>;
        return <>{
            props.super ?
                (row.Pendiente ?
                    <>
                        {/* super && pendiente */}
                        {viewBtn}
                        <Button title="Aprobar" action="validate" variant="success" size="sm" onClick={props.onAction}><FontAwesomeIcon icon={faCheck} /></Button>
                        <Button title="Denegar" action="invalidate" variant="danger" size="sm" onClick={props.onAction}><FontAwesomeIcon icon={faTimes} /></Button>
                    </> :
                    (row.Validado ? <>
                        {/* super && !pendiente && validado */}
                        {viewBtn}
                        <Button title="Cancelar" action="cancel" variant="outline-danger" size="sm" onClick={props.onAction}><FontAwesomeIcon icon={faBan} /></Button>
                    </> : <>
                        {/* super && !pendiente && !validado */}
                        {viewBtnOutlined}
                    </>)
                ) :
                (row.Pendiente ?
                    <>
                        {/* !super && pendiente */}
                        {viewBtn}
                        <Button variant="secondary" size="sm" onClick={props.onEdit}><FontAwesomeIcon icon={faEdit} /></Button>
                        <Button variant="danger" size="sm" onClick={props.onDelete}><FontAwesomeIcon icon={faTrash} /></Button>
                    </> : (row.Validado ? <>
                        {/* !super && !pendiente && validado */}
                        {viewBtn}
                    </> : <>
                        {/* !super && !pendiente && !validado */}
                        {viewBtnOutlined}
                    </>)
                )
        }</>;
    };
    const name = row => `${row.NombreTrabajador}, ${moment(row.Fecha).format("DD/MM/YY")} (${row.StrHoraInicio}-${row.StrHoraFin})`;

    return <>
        <DataTable responsive rowname={name} buttons={buttons} columns={columns} data={props.data} pagination />
        {props.formOpen && (
            <PermisoModal
                show={props.formOpen}
                onHide={props.onFormClose}
                idPermiso={props.formId}
                permisoAdmin={props.user.permisoAdmin}
                super={props.super}
            />
        )}
        <FloatingAddButton onClick={props.onNew} />
    </>;
}
